import { render, staticRenderFns } from "./IntegrazioneBusinessList.vue?vue&type=template&id=6ad532f8"
import script from "./IntegrazioneBusinessList.vue?vue&type=script&lang=js"
export * from "./IntegrazioneBusinessList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports